export default {
  casino: () => import("/home/msservice/source/prod/fe/layouts/casino.vue"),
  default: () => import("/home/msservice/source/prod/fe/layouts/default.vue"),
  errordefault: () => import("/home/msservice/source/prod/fe/layouts/errordefault.vue"),
  events: () => import("/home/msservice/source/prod/fe/layouts/events.vue"),
  games: () => import("/home/msservice/source/prod/fe/layouts/games.vue"),
  news: () => import("/home/msservice/source/prod/fe/layouts/news.vue")
}